






























































































































































































































































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from "lodash";
import MyForm from "@/mixins/form";

import AreaPicker from "@/components/areapicker.vue";

import Amap from "@/components/amap.vue";

@Component({
  components: {
    AreaPicker,
    Amap,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  amapcity: any = '';

  amapaddr = '';

  amapcallback(lng: any, lat: any) {
    // console.log(lng);
    // console.log(lat);
    this.form.setFieldsValue({
      lnglat: `${lng},${lat}`,
    });
  }

  addressChange() {
    // console.log("222");
    this.$nextTick(() => {
      // console.log(this.form.getFieldValue("addr"));
      this.amapaddr = this.form.getFieldValue('addr');
      const areastr: string[] = this.form.getFieldValue('area');

      this.amapcity = areastr;
      // console.log(this.amapaddr);
      // console.log(this.amapcity);
    });
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        // nothing to do
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch('enterapply/detail', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }

  async changeSaleUser(form: any, permKey?: string) {
    this.$nextTick(() => {
      const mobile = form.getFieldValue('sale_mobile');
      const cb: any = (err: any, values: any) => {
        if (!err) {
          this.showTsConfirm({
            title: "确认信息",
            content: `确定修改商务经理吗？`,
            onOk: async () => {
              if (permKey) {
                // 需要判断权限
                if (!this.checkPermission(permKey)) {
                  this.$message.warning("没有权限");
                  return;
                }
              }
              // console.log(this.$store.state)
              const res = await this.$store.dispatch("stadium/saveSaler", {stadium_id:this.stadiumId,mobile:mobile});
              // console.log(res)
              if (res && parseInt(res.Code, 10) === 200) {
                this.$message.success(res.Message);
              } else {
                this.$message.error(res.Message);
              }
            },
          });
        }
      };
      form.validateFields(['sale_mobile'], { force: true }, cb);
    });
  }

}
